<template>
  <div class="mod_top_list">
            <div class="top_list">
                <dl class="user_info cf">
                    <dt>
                        <span class="pic">
                        <img :src="user.avatar | urlNormalize" v-errpic="defaultAvatar">
                        <span class="mask_crown"></span>
                        <i v-if="!isTakeUser && userInfo" :class="'u_icon_'+userInfo.type"></i>
                        </span>
                    </dt>
                    <dd>
                        <p class="tit">
                            <span class="name">{{user.nick}}</span>
                            <span v-if="isTakeUser" :class="giveUser.giveUserVipIcon"></span>
                            <VipIcon :payVip="payVipInfo" :useShort="false" :useYearIcon="false" v-if="!isTakeUser && payVipInfo"></VipIcon>
                            <a v-if="!hideChangeAccount" class="change" @click="switchLogin">切换账号</a>
                        </p>
                        <div class="info">
                            <p class="txt1">{{cover.coverTitleText}}</p>
                            <p class="txt2" v-html="cover.giveInfoText"></p>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>

</template>

<script>
import env from '@tencent/vft-common/env'
import VipIcon from '@tencent/vft-ui/src/VipIcon/VipIcon.vue'

export default {
  props: ['giveUser', 'cover'],
  data () {
    return {
    }
  },
  methods: {
    switchLogin () {
      this.$switchLogin({
        type: this.loginType() === 'wx' ? 'qq' : 'wx'
      })
    }
  },
  computed: {
    hideChangeAccount () {
      return env.isMqq || env.isApp || this.isTakeUser
    },
    user () {
      if (this.isTakeUser) {
        return {
          avatar: this.giveUser.head,
          nick: this.giveUser.nick
        }
      }
      return {
        avatar: this.userInfo.headurl,
        nick: this.userInfo.nick
      }
    }
  },
  components: {
    VipIcon
  }
}
</script>
<style>
.mod_top_list .vft-vip-subscript .img-vip-subscript{position: relative;top: -7px;left: 5px;}
</style>
